import qrcodeGenerator from 'qrcode-generator';

const QUIET_ZONE = 4;

export function qrModules(text: string): boolean[][] {
  const qr = qrcodeGenerator(0, 'M');
  qr.addData(text, 'Byte');
  qr.make();
  const count = qr.getModuleCount();
  return Array.from({ length: count }, (_, row) => Array.from({ length: count }, (_, col) => qr.isDark(row, col)));
}

export function QrCode({ text, size, label }: { text: string; size: number; label: string }) {
  const modules = qrModules(text);
  const side = modules.length + QUIET_ZONE * 2;
  const path = modules
    .flatMap((row, r) => row.map((dark, c) => (dark ? `M${c + QUIET_ZONE},${r + QUIET_ZONE}h1v1h-1z` : '')))
    .filter(Boolean)
    .join('');
  return (
    <svg
      data-testid="qr-code"
      data-modules={modules.length}
      viewBox={`0 0 ${side} ${side}`}
      width={size}
      height={size}
      shapeRendering="crispEdges"
      role="img"
      aria-label={label}
      style={{ display: 'block', flexShrink: 0 }}
    >
      <rect width={side} height={side} fill="#FFFFFF" />
      <path d={path} fill="#000000" />
    </svg>
  );
}
